export const updateCSSVariables = (color) => {
  if (color) {
    document.documentElement.style.setProperty("--primary-color", color);
  }
};
